<template>
  <v-menu
    v-model="menu"
    offset-y
    min-width="290px"
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        :value="timeValue"
        :label="labelText"
        persistent-hint
        append-icon="event"
        readonly
        v-on="on"
        :dense="dense"
        :clearable="clear"
      ></v-text-field>
    </template>
    <v-time-picker
      v-if="menu"
      :value="timeValue"
      @change="onChange"
      no-title
    >
    </v-time-picker>
  </v-menu>
</template>

<script>
export default {
  name: 'TimePicker',
  data() {
    return {
      menu: false
    }
  },
  props: {
    labelText: {
      type: String,
      required: true
    },
    timeValue: {
      type: String || null,
      required: false
    },
    dense: {
      type: Boolean,
      default: false
    },
    clear: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onChange(time) {
      this.menu = false
      this.$emit('update:timeValue', time)
    }
  }
}
</script>
